import { Inject, Injectable } from '@angular/core';
import { WINDOW } from '@campus/browser';
import { Observable } from 'rxjs';
import { EduFileApi } from '../+api';
import { EduFileInterface, EduFileTypeEnum, StorageInfoInterface } from '../+models';

@Injectable({
  providedIn: 'root',
})
export class EduFileService {
  constructor(private eduFileApi: EduFileApi, @Inject(WINDOW) private window: Window) {}

  getAll(): Observable<EduFileInterface[]> {
    return this.eduFileApi.find();
  }

  getAllArtifacts(): Observable<EduFileInterface[]> {
    return this.eduFileApi.find({ where: { type: EduFileTypeEnum.ARTIFACT } });
  }

  uploadFile(eduContentId: number, file: File, type?: EduFileTypeEnum): Observable<StorageInfoInterface> {
    const formData: FormData = new FormData();

    if (file) {
      formData.set('file', file, file.name);
    }

    if (type) {
      formData.set(type, 'true');
    }

    return this.eduFileApi.uploadFile(eduContentId, formData);
  }

  downloadFileFromMetadata(eduContentMetadataId: number, type: EduFileTypeEnum = EduFileTypeEnum.EXERCISE): void {
    const downloadUrl = this.eduFileApi.downloadFileFromMetadata(eduContentMetadataId, type);
    this.window.open(downloadUrl);
  }

  downloadEduFile(eduFileId: number): void {
    const downloadUrl = this.eduFileApi.downloadEduFile(eduFileId);
    this.window.open(downloadUrl);
  }

  deleteFile(eduFileId: number): Observable<boolean> {
    return this.eduFileApi.deleteFile(eduFileId);
  }

  getRedirectUrlRemote(eduFileId: number): Observable<string> {
    return this.eduFileApi.redirectUrlRemote(eduFileId);
  }
}
